import { widgetState } from '../../store/customizations/index'

const formSelector = "form[action^='/cart/add']"

export const injectWidget = (currentElement: HTMLElement, mainElement: HTMLElement): void => {
  const isInStore = widgetState.customizations.isDresser || (!widgetState.customizations.isReadOnly && !widgetState.customizations.isPreview)
  const autoInjectEnabled = isInStore &&
                            widgetState.customizations.autoInject.enabled
  if (!autoInjectEnabled) {
    injectIntoPlaceholder(currentElement, mainElement)
    return
  }
  const adjacentStrategy = widgetState.customizations.autoInject.adjacentStrategy || getAdjacentStrategy()
  const targetElement = getInjectionTargetElement()
  if (isElementInForm(targetElement)) {
    targetElement.insertAdjacentElement(adjacentStrategy, mainElement)
    return
  }
  if (!targetElement && isElementInForm(currentElement)) {
    injectIntoPlaceholder(currentElement, mainElement)
    return
  }
  throw new Error('element is not within a form')
}

export const getFormElement = (): Element | null => {
  let injectionTargetElement = getInjectionTargetElement()
  while (injectionTargetElement && injectionTargetElement.parentNode && injectionTargetElement.nodeName.toLowerCase() !== 'form') {
    injectionTargetElement = injectionTargetElement.parentElement
  }
  if (injectionTargetElement) {
    return injectionTargetElement.nodeName.toLowerCase() === 'form' ? injectionTargetElement : null
  }
  return null
}

export const getAutoInjectSelector = (): string => {
  if (!isElementExists(formSelector)) {
    return ''
  }
  const buttonSelector = "button[type^='submit']"
  const inputSelector = "input[type^='submit']"
  const selectorPriorities = [buttonSelector, inputSelector]
  return findInElement(formSelector, selectorPriorities)
}

export const getAdjacentStrategy = (): 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' => {
  const autoInjectSelector = getAutoInjectSelector().toString()
  if (autoInjectSelector) {
    const autoInjectSelectorElement = document.querySelectorAll(autoInjectSelector)
    const isButtonOrInput = autoInjectSelectorElement[autoInjectSelectorElement.length - 1].nodeName.toLowerCase()
    if (isButtonOrInput === 'button' || isButtonOrInput === 'input') {
      return 'beforebegin'
    }
  }
  return 'afterbegin'
}

const isElementExists = (selector: string): boolean => {
  return document.querySelectorAll(selector).length > 0
}

const injectIntoPlaceholder = (currentElement: HTMLElement, mainElement: HTMLElement) => {
  currentElement.parentNode.replaceChild(mainElement, currentElement)
}

const isElementInForm = (element: Element): boolean => {
  if (!element) {
    return false
  }
  let isForm = element
  while (isForm && isForm.parentNode && isForm.nodeName.toLowerCase() !== 'form') {
    isForm = isForm.parentElement
  }
  if (isForm) {
    return isForm.nodeName.toLowerCase() === 'form'
  }
  return false
}

const findInElement = (parentSelector: string, selectorsPriority: string[]): string => {
  for (let i = 0; i < selectorsPriority.length; i++) {
    const selector = `${parentSelector} ${selectorsPriority[i]}`
    if (isElementExists(selector)) {
      return selector
    }
  }
  return parentSelector
}

const getInjectionTargetElement = (): Element | null => {
  const isTargetSet = !!widgetState.customizations.autoInject.targetSelector
  const selector = widgetState.customizations.autoInject.targetSelector || getAutoInjectSelector()

  if (!selector) {
    return null
  }

  let formPlace = 'last'
  if (!isTargetSet) {
    const hasMoreThan3Forms = document.querySelectorAll(formSelector).length >= 3
    if (hasMoreThan3Forms) {
      formPlace = 'first'
    }
  }

  const hostElements = document.querySelectorAll(selector)
  if (hostElements.length === 0) {
    return null
  }
  if (formPlace === 'first') {
    return hostElements[0]
  }
  return hostElements[hostElements.length - 1]
}
